// Read-only viewer for a Milestone, rendered as a modal. Primary use is
// the archived-item deep-link flow. In-page is MilestoneDetailExpand.

import Modal from "../../../common/Modal";
import Button from "../../../common/Button";
import MilestoneDetailExpand from "./MilestoneDetailExpand";
import type { Milestone } from "../../../../types";

interface MilestoneDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: Milestone | null;
}

export default function MilestoneDetailModal({
  isOpen,
  onClose,
  item,
}: MilestoneDetailModalProps) {
  if (!item) return null;
  const isArchived = !!item.archivedAt;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isArchived ? "Milestone (archived)" : "Milestone"}
      maxWidth="sm:max-w-2xl"
    >
      <div className="space-y-4">
        <MilestoneDetailExpand item={item} />

        <div className="flex justify-end gap-3 pt-2">
          {isArchived && (
            <Button
              variant="secondary"
              disabled
              title="Unarchive to edit — coming soon (self-service)"
              aria-label="Unarchive to edit — coming soon (self-service)"
            >
              Unarchive to edit
            </Button>
          )}
          <Button variant="primary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
}
